import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import { AlertifyService } from 'src/app/recursos/alertify.service';
import { SeleccionService } from '../../servicios/seleccion.service';
import { ToolsService } from '../../recursos/tools.service';
import { LoaderComponent } from '../../servicios/loader/loader.component';
import { Subject } from 'rxjs';
import { IngresoService } from '../../servicios/ingreso.service';
import { Router } from '@angular/router';


@Component({
  selector: 'app-encuesta',
  templateUrl: './encuesta.component.html',
  styleUrls: ['./encuesta.component.css']
})
export class EncuestaComponent implements OnInit {

  public mr: NgbModalRef;
  @ViewChild(DataTableDirective)
  dtOptionsGrupo: DataTables.Settings = {};
  public dtTriggerGrupo: Subject<any>;

  public encabezado: string = ""; public nombreBeca: string = ""; public tituloModal: string = ''; opGestion: number = 0;
  fechaHoy: string = ""; horaHoy: string = "";
  public vecAddEncuesta = []; public vecVerEncuestas = [];

  constructor(private modalService: NgbModal, private alerti: AlertifyService, private srvInsert: IngresoService, private cargando: LoaderComponent,
    private srvSelect: SeleccionService, private tools: ToolsService, private ruta: Router) { }

  ngOnInit() {
    this.dtTriggerGrupo = new Subject<any>();
    this.dtOptionsGrupo[0] = this.tools.OpcionesTabla(10);

    this.calculoFecha();
    this.verEncuestas();
    this.encabezado = "Pisicología educativa";
    this.nombreBeca = localStorage.getItem('modNom');
    this.instanciaVariables(0, '', '', '', '', 0, 1);
  }

  //MOSTRAR EL LISTADO DE TODOS LOS GRUPOS REGISTRADOS
  async verEncuestas() {
    var table2 = $('#tblGrupo').DataTable({
      destroy: true
    });
    table2.destroy();

    this.cargando.abrir();
    this.vecVerEncuestas = [];
    const resGrupo = await new Promise<any>(resolve =>
      this.srvSelect.gestionEncuesta(10, 'na', 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resGrupo.success) {
      this.vecVerEncuestas = resGrupo.encuesta;
      this.dtTriggerGrupo.next();
    }
    else
      this.alerti.message('No se encntró información de encuestas registradas');
    this.cargando.cerrar();
  }

  //ABRIR EL MODAL QUE PERMITE AGREGAR UN GRUPO DE PREGUNTAS
  verModGrupo(nombModal) {
    if (localStorage.getItem('insUser') == 'true') {
      this.tituloModal = 'Registrar una nueva encuesta';
      this.opGestion = 6;
      this.instanciaVariables(0, '', '', '', '', 0, 1);
      this.mr = this.modalService.open(nombModal);
    }
    else
      this.alerti.error("Este perfil no tiene permiso para esta actividad");
  }
  //ABRIR EL MODAL QUE PERMITE EDITAR UNA ENCUESTA
  verModEncuesta(nombModal, encuesta) {
    if (localStorage.getItem('modUser') == 'true') {
      this.tituloModal = 'Encuesta a ser modificada';
      this.opGestion = 8;
      this.instanciaVariables(encuesta.intIdEncuesta, encuesta.strNombre, encuesta.strDescripcion, encuesta.strRecomendacion, encuesta.strTerminos,
        encuesta.fltTiempo, encuesta.intEstado);
      this.mr = this.modalService.open(nombModal);
    }
    else
      this.alerti.error("Este perfil no tiene permiso para esta actividad");
  }
  //REGISTRAR UN NUEVO GRUPO
  ingresoGrupo() {
    this.gestionGrupo(this.vecAddEncuesta[0]['nombre'], this.vecAddEncuesta[0]['detalle'], this.vecAddEncuesta[0]['recomendacion'], this.vecAddEncuesta[0]['termino'],
      this.vecAddEncuesta[0]['tiempo'], localStorage.getItem('idPersona'), this.fechaHoy, this.vecAddEncuesta[0]['estado'], this.vecAddEncuesta[0]['encuesta'], this.opGestion);
  }
  //GESTIONA LAS ACTIVADES A REALIZAR SOBRE EL GRUPO INGRESAR - EDITAR
  gestionGrupo(param1, param2, param3, param4, param5, param6, param7, param8, param9, op) {
    this.srvInsert.ingresoEncuesta(param1, param2, param3, param4, param5, param6, param7, param8, param9, 'na', op).subscribe(res => {
      if (res.encuesta) {
        this.alerti.success('Datos registrados correctamente');
        this.verEncuestas();
        this.cerrarModal();
      }
      else
        this.alerti.error('Error inesperado vuelva a intentar más tarde');
    });
  }
  //INSTANCIAR VARIABLES
  instanciaVariables(dato1, dato2, dato3, dato4, dato5, dato6, dato7) {
    this.vecAddEncuesta = [];
    this.vecAddEncuesta.push({ encuesta: dato1, nombre: dato2, detalle: dato3, recomendacion: dato4, termino: dato5, tiempo: dato6, estado: dato7 });
  }
  //IR A LA PAGINA DE LAS PREGUNTAS QUE CORRESPONDE A LA ENCUESTA SELECCIOANDA
  verPreguntas(objFicha) {
    localStorage.setItem('localNumEnc', objFicha.intIdEncuesta);
    this.ruta.navigate(["/gestion/encuestaGrupo"]);
  }
  //FUNCIÓN QUE CALCULA LA FECHA ACTUAL DEL SISTEMA
  calculoFecha() {
    var hoy = new Date();
    var diahoy = hoy.getDate() < 10 ? "0" + hoy.getDate() : hoy.getDate();
    var meshoy = (hoy.getMonth() + 1) < 10 ? "0" + (hoy.getMonth() + 1) : (hoy.getMonth() + 1);
    var annohoy = hoy.getFullYear();

    this.fechaHoy = annohoy + "-" + meshoy + "-" + diahoy;
    this.horaHoy = hoy.getHours() + "_" + hoy.getMinutes();
  }
  cerrarModal() {
    this.mr.close();
  }
}
